import React from 'react';
import './MaintenanceBackground.css';

/**
 * Decorative radial dot-pattern backdrop used behind the maintenance page
 * content. Purely presentational, so it is hidden from assistive tech.
 */
function MaintenanceBackground() {
  return <div className="MaintenanceBackground" aria-hidden="true" />;
}

export default MaintenanceBackground;
